export const readStorage = (key, fallback = null) => {
  try {
    const raw = localStorage.getItem(key)
    if (raw === null || raw === undefined) return fallback
    try {
      return JSON.parse(raw)
    } catch (_) {
      return raw
    }
  } catch (_) {
    return fallback
  }
}

export const readRawStorage = (key) => {
  try {
    return localStorage.getItem(key)
  } catch (_) {
    return null
  }
}

export const writeStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
    return true
  } catch (_) {
    return false
  }
}

export const clearStorage = () => {
  try {
    localStorage.clear()
    return true
  } catch (_) {
    return false
  }
}
